import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';
import dashedLine from './dashed-line.svg';
import Charm from '../Charm';
import DesignOptions from 'components/SeriesDetail/DesignOptions';
import MiniSecondaryOption from 'components/SeriesDetail/MiniSecondaryOption';

export const SearchTemplate = ({
  addedToReview,
  formattedDesignPrice,
  formattedTotal,
  interiorOption,
  paintOption,
  formattedPriceBand,
  suggestedQuant,
  trimOption,
  wheelOption,
  addTemplate,
  templateId,
  modelId,
  addIcon,
  charmsForTemplate,
  mini,
  expand,
  collapse,
  expanded,
  primaryOptions,
  secondaryOptions,
  onClickOrTouch,
  selectedDesignOption,
  designPackageForTemplate,
  displayPlaceholder,
}) => (
  <div className={styles.templateView}>
    <div className={styles.template}>
      <span className={styles.selectedOptions}>
        <DesignOptions
          designPackage={designPackageForTemplate}
          onClickOrTouch={onClickOrTouch}
          selectedDesignOption={selectedDesignOption}
          isDuplicate={'false'}
          templateId={templateId}
          mini={mini}
          expand={expand}
          primaryOptions={primaryOptions}
          secondaryOptions={secondaryOptions}
        />
        <span className={styles.designPrice}>+ {formattedDesignPrice}</span>
      </span>
      <span className={styles.priceBand}>({formattedPriceBand})</span>
      <span className={styles.totalPrice}>{formattedTotal}</span>
      <span className={styles.suggestedQuant}>{suggestedQuant}</span>
      <span className={styles.charms}>
        {charmsForTemplate.map(charm => (
          <Charm charm={charm} detail={false} />
        ))}
      </span>
      <span className={styles.selectedQuantityStatic}>
        <img alt="dashes" src={dashedLine} />
      </span>
      <span className={styles.priority}>
        <img alt="dashes" src={dashedLine} />
      </span>
      <span className={styles.skinnyColumn} />
      {displayPlaceholder ? (
        <span className={styles.addButton}>{addedToReview}</span>
      ) : (
        <span
          data-templateId={templateId}
          data-modelId={modelId}
          onClick={addTemplate}
          className={styles.addButton}
        >
          <img alt="add" src={addIcon} />
        </span>
      )}
    </div>
    {mini &&
      expanded && (
        <div className={styles.secondaryOptions} onClick={collapse}>
          <div className={styles.secondaryOptionsInner}>
            <span className={styles.options}>
              {secondaryOptions.map(optionKey => (
                <MiniSecondaryOption
                  key={optionKey}
                  optionKey={optionKey}
                  designPackage={designPackageForTemplate}
                />
              ))}
            </span>
          </div>
          <div className={styles.outerArea} onClick={collapse} />
        </div>
      )}
  </div>
);

export default enhance(SearchTemplate);
